// src/services/reportReminderStore.js
//
// Remembers a coordinator's choice on the weekly-report reminder (snoozed
// until when, or dismissed for the day) in this browser, per signed-in user
// AND per company + site: a coordinator at two sites files a report for each,
// so dismissing it at one site must not hide it at the other.
// A per-viewer convenience only: if storage is blocked or the value is
// corrupt, the reminder simply shows again. No patient data is stored here.
// Rules for what the state means live in reportReminderSchedule.js.

export const reminderKey = (uid, tenantId, siteId) =>
  `regx.reportReminder.v2.${uid}.${tenantId || "-"}.${siteId || "-"}`;

export const loadReminderState = (uid, tenantId, siteId) => {
  if (!uid) return null;
  try {
    const raw = window.localStorage.getItem(reminderKey(uid, tenantId, siteId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null; // private mode, blocked storage, or corrupt JSON
  }
};

export const saveReminderState = (uid, tenantId, siteId, state) => {
  if (!uid) return;
  try {
    window.localStorage.setItem(reminderKey(uid, tenantId, siteId), JSON.stringify(state));
  } catch {
    /* non-fatal: the reminder just shows again */
  }
};
